import React from 'react';
import { ErrorMessage } from 'formik';

type Props = {
  name: string;
  message?: string;
};

const FormError = (props: Props) => <ErrorMessage {...props} render={message => <span className="form-error">{props.message || message}</span>} />;

export default FormError;
